(function(){
  function setupPersonalizationValidation(form){
    Array.from(form.querySelectorAll('[data-custom-personalization]')).forEach(function(input){
      var pattern=input.getAttribute('pattern')||'';
      if(pattern!=='[\\p{L}\\p{M}0-9]+(?: [\\p{L}\\p{M}0-9]+)*')return;
      if(input.dataset.formatHelpReady==='true')return;input.dataset.formatHelpReady='true';
      var described=(input.getAttribute('aria-describedby')||'').trim();
      var hintId=described.split(/\s+/).filter(Boolean)[0];
      var hint=hintId?document.getElementById(hintId):null;
            var errorId=(input.id||'pet-name')+'-format-error';
      var formatError=document.getElementById(errorId);
      if(!formatError){
        formatError=document.createElement('p');formatError.id=errorId;formatError.className='al-error';formatError.hidden=true;formatError.setAttribute('aria-live','polite');
        if(hint)hint.insertAdjacentElement('afterend',formatError);else input.insertAdjacentElement('afterend',formatError);
      }
      if(described.split(/\s+/).indexOf(errorId)===-1)input.setAttribute('aria-describedby',(described+' '+errorId).trim());
      function hideOwnError(){
        if(input.dataset.formatErrorActive==='true'){input.setCustomValidity('');input.dataset.formatErrorActive='false';}
        formatError.textContent='';formatError.hidden=true;
      }
      function showPatternError(){
        var message=input.dataset.formatError||form.dataset.errorMessage||'Invalid value';input.setCustomValidity(message);input.dataset.formatErrorActive='true';input.setAttribute('aria-invalid','true');formatError.textContent=message;formatError.hidden=false;
      }
      function refreshPatternState(){
        hideOwnError();
        if(input.value&&input.validity.patternMismatch)showPatternError();
      }
      input.addEventListener('invalid',function(){if(input.validity.patternMismatch)showPatternError();});
      input.addEventListener('input',refreshPatternState);
      input.addEventListener('blur',refreshPatternState);
    });
  }

  function init(){
    document.querySelectorAll('#Cart-order-note').forEach(function(note){
      if(note.dataset.noteReady)return;note.dataset.noteReady='true';
      var form=note.form,queue=Promise.resolve(),saved=note.value;
      function save(){
        var value=note.value;
        queue=queue.catch(function(){}).then(async function(){
          if(value===saved)return;
          var response=await fetch(form.action.replace(/\/$/,'')+'/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({note:value}),keepalive:true});
          if(!response.ok)throw new Error('note');
          var cart=await response.json();
          if(cart.note!==value)throw new Error('note');
          saved=value;note.setCustomValidity('');
        });
        queue.catch(function(){note.setCustomValidity(note.dataset.saveError);});
        return queue;
      }
      note.addEventListener('input',function(){note.setCustomValidity('');save();});
      note.addEventListener('change',save);
      form.addEventListener('submit',function(event){
        if(form.dataset.noteSaved==='true')return;
        event.preventDefault();var submitter=event.submitter;
        save().then(function(){form.dataset.noteSaved='true';form.requestSubmit(submitter);}).catch(function(){note.reportValidity();});
      });
    });

    document.querySelectorAll('[data-product-form]').forEach(function(form){
      if(form.dataset.commerceReady)return;form.dataset.commerceReady='true';
      setupPersonalizationValidation(form);
      var button=form.querySelector('[data-submit-button]'),error=form.querySelector('[data-product-error]'),busy=false;
      function showError(message){if(!error)return;error.textContent=message;error.hidden=false;if(typeof error.focus==='function')error.focus();}
      form.addEventListener('submit',async function(event){
        if(event.defaultPrevented)return;
        if(busy||(button&&button.disabled)||form.getAttribute('aria-busy')==='true'){event.preventDefault();return;}
        if(!form.reportValidity()) {event.preventDefault();return;}
        if(form.querySelector('input[type="file"]'))return;
        event.preventDefault();busy=true;if(button)button.disabled=true;form.setAttribute('aria-busy','true');if(error)error.hidden=true;
        try{
          var response=await fetch(form.action+'.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
          var data=await response.json();
          if(!response.ok)throw new Error(data.description||data.message||form.dataset.errorMessage);
          window.location.assign(form.dataset.cartUrl);
        }catch(err){showError(err.message||form.dataset.errorMessage);busy=false;if(button)button.disabled=false;form.removeAttribute('aria-busy');}
      });
    });
    document.querySelectorAll('[data-cart-change]').forEach(function(form){
      if(form.dataset.commerceReady)return;form.dataset.commerceReady='true';
      form.addEventListener('submit',async function(event){
        if(!event.submitter)return;
        event.preventDefault();
        if(form.getAttribute('aria-busy')==='true')return;
        var data=new FormData(form);data.set('quantity',event.submitter.value);
        var error=form.querySelector('[data-cart-error]');if(error)error.hidden=true;form.setAttribute('aria-busy','true');
        var buttons=Array.from(form.querySelectorAll('button')),states=buttons.map(function(b){return b.disabled;});buttons.forEach(function(b){b.disabled=true;});
        try{
          var response=await fetch(form.action+'.js',{method:'POST',body:data,headers:{Accept:'application/json'}});
          var result=await response.json();
          if(!response.ok)throw new Error(result.description||result.message||form.dataset.errorMessage);
          window.location.reload();
        }catch(err){if(error){error.textContent=err.message||form.dataset.errorMessage;error.hidden=false;if(typeof error.focus==='function')error.focus();}form.removeAttribute('aria-busy');buttons.forEach(function(b,i){b.disabled=states[i];});}
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();